import axios from 'axios'
import { Message } from 'element-ui';
import Router from '../router'


let hostURL = 'https://api.gd-caxin.com'
// hostURL = 'http://47.100.81.66:45894'

// 创建axios实例
const request = axios.create({
  baseURL: hostURL,
  timeout: 6000000,// 请求超时时间
})

//响应拦截器
request.interceptors.response.use(res => {
  if (!!res.data.code && res.data.code != 200) {
    if (res.data.code === 401) {
      Router.push("/login") //跳转到登陆页面
      localStorage.clear()
    }
    Message({
      showClose: true,
      message: res.data.message || "未知错误",
      type: 'warning',
    })
  }
  return res
}, error => {
  Message({
    showClose: true,
    message: "内部错误",
    type: 'error',
  })
  return error.response
});

//请求拦截器
request.interceptors.request.use(config => {
  const userData = sessionStorage.getItem('userData')
  const { token } = userData ? JSON.parse(userData) : {}
  if (token) {
    config.headers['Ac-Token'] = token
  }

  return config
}, error => {
  console.log('请求出错了', error)
});

export { hostURL }
export default request